// MENU_REGRA_0311 (GROK2): aplica as regras do Gustavo no menu lateral (esconde, nunca apaga código).
// Admin: Dashboard, Clientes, Testes, Financeiro, Revendas, Migração por M3U, Catálogo e Planos, Conteúdos, WhatsApp, Equipe, Ajustes.
// Revenda: Dashboard, Financeiro, Clientes, Testes, Catálogo e Planos, Conteúdos, Apps parceiros, WhatsApp, Equipes (+ Extras / Meus extras).
// Páginas fora da lista continuam abrindo pela URL. Switch private/MENU_REGRA_0311_OFF.
const norm = (s) => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
const ADMIN = [['dashboard', 'painel'], ['clientes'], ['testes'], ['financeiro'], ['revendas'], ['migracao'], ['catalogo', 'planos'], ['conteudos'], ['whatsapp'], ['equipe'], ['ajustes']];
const REV = [['dashboard', 'painel'], ['financeiro'], ['clientes'], ['testes'], ['catalogo', 'planos'], ['conteudos'], ['apps parceiros', 'apps'], ['whatsapp'], ['equipe'], ['extras'], ['meus extras']];
function rank(label, list) {
  const l = norm(label);
  for (let i = list.length - 1; i >= 0; i -= 1) if (list[i].some((k) => l === k || l.startsWith(k + ' ') || l.startsWith(k))) return i;
  return -1;
}
// VENC_MENU_0411: Vencimentos faltava nas listas -> sumia do menu de todos. Switch private/VENC_MENU_0411_OFF.
const comVenc = (l) => { const i = l.findIndex((k) => k[0] === 'testes'); return [...l.slice(0, i + 1), ['vencimentos'], ...l.slice(i + 1)]; };
// REVENDA_ABA_MAT_0411: Matheus (167/169) ve a aba Revendas (lista REV nao tinha). Switch private/REVENDA_ABA_MAT_0411_OFF.
const comRev = (l) => { const i = l.findIndex((k) => k[0] === 'whatsapp'); return [...l.slice(0, i), ['revendas'], ...l.slice(i)]; };
export function menuRegra0311(groups = [], { isAdmin, venc, rev }) {
  const base = isAdmin ? ADMIN : (rev ? comRev(REV) : REV);
  const list = venc ? comVenc(base) : base;
  const flat = [];
  groups.forEach((g) => {
    const its = g.items || [];
    const rg = rank(g.label, list);
    if (rg >= 0 || its.length <= 1) { flat.push({ g, r: rg >= 0 ? rg : rank(its[0]?.label, list) }); return; }
    its.forEach((it) => flat.push({ g: { ...g, id: `${g.id || 'g'}-${it.path}`, label: it.label, items: [it], defaultPath: it.path }, r: rank(it.label, list) }));
  });
  const ok = flat.filter((x) => x.r >= 0);
  if (ok.length < 5) return groups; // segurança: se os nomes mudarem, não some o menu
  const seen = new Set();
  return ok.sort((a, b) => a.r - b.r).map((x) => x.g).filter((g) => { const k = (g.items || [])[0]?.path || g.id; if (seen.has(k)) return false; seen.add(k); return true; });
}
